import { render } from "./maternity_newborn.vue?vue&type=template&id=b9d66c84&scoped=true"
import script from "./maternity_newborn.vue?vue&type=script&lang=js"
export * from "./maternity_newborn.vue?vue&type=script&lang=js"

import "./maternity_newborn.vue?vue&type=style&index=0&id=b9d66c84&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d66c84"]])

export default __exports__